import './UserManualView.css';

function UserManualView() {

  return (
    <div>
      <a href="/static/SlideforNET_User_Manual_v0.3.0.pdf">Click here to download the PDF</a>
      <object data="/static/SlideforNET_User_Manual_v0.3.0.pdf" type="application/pdf" style={{ width: "100%", height: "100vh" }}>
        <p>Here is a link <a href="/static/SlideforNET_User_Manual_v0.3.0.pdf">to the PDF!</a></p>
      </object>
    </div>
  );
}

export default UserManualView;
